"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemeChangesApi = exports.SchemeChangesApiFactory = exports.SchemeChangesApiFp = exports.SchemeChangesApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * SchemeChangesApi - axios parameter creator
 * @export
 */
const SchemeChangesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get scheme edits
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemeHistory: (schemeId_1, ...args_1) => __awaiter(this, [schemeId_1, ...args_1], void 0, function* (schemeId, options = {}) {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('getSchemeHistory', 'schemeId', schemeId);
            const localVarPath = `/schemeChanges/{schemeId}/history`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get scheme edits, done by other user
         * @param {string} otherUser
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemeHistoryForUser: (otherUser_1, schemeId_2, ...args_2) => __awaiter(this, [otherUser_1, schemeId_2, ...args_2], void 0, function* (otherUser, schemeId, options = {}) {
            // verify required parameter 'otherUser' is not null or undefined
            (0, common_1.assertParamExists)('getSchemeHistoryForUser', 'otherUser', otherUser);
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('getSchemeHistoryForUser', 'schemeId', schemeId);
            const localVarPath = `/schemeChanges/{schemeId}/history/{otherUser}`
                .replace(`{${"otherUser"}}`, encodeURIComponent(String(otherUser)))
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get other users that have edited the scheme
         * @param {string} schemeId
         * @param {Array<number>} [changes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeChangeResourceApplyChanges: (schemeId_3, changes_1, ...args_3) => __awaiter(this, [schemeId_3, changes_1, ...args_3], void 0, function* (schemeId, changes, options = {}) {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('schemeChangeResourceApplyChanges', 'schemeId', schemeId);
            const localVarPath = `/schemeChanges/{schemeId}/applyChanges`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (changes) {
                localVarQueryParameter['changes'] = changes;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get other users that have edited the scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeChangeResourceGetEditors: (schemeId_4, ...args_4) => __awaiter(this, [schemeId_4, ...args_4], void 0, function* (schemeId, options = {}) {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('schemeChangeResourceGetEditors', 'schemeId', schemeId);
            const localVarPath = `/schemeChanges/{schemeId}/editors`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SchemeChangesApiAxiosParamCreator = SchemeChangesApiAxiosParamCreator;
/**
 * SchemeChangesApi - functional programming interface
 * @export
 */
const SchemeChangesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SchemeChangesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get scheme edits
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemeHistory(schemeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSchemeHistory(schemeId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SchemeChangesApi.getSchemeHistory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get scheme edits, done by other user
         * @param {string} otherUser
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemeHistoryForUser(otherUser, schemeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSchemeHistoryForUser(otherUser, schemeId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SchemeChangesApi.getSchemeHistoryForUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get other users that have edited the scheme
         * @param {string} schemeId
         * @param {Array<number>} [changes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeChangeResourceApplyChanges(schemeId, changes, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeChangeResourceApplyChanges(schemeId, changes, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SchemeChangesApi.schemeChangeResourceApplyChanges']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get other users that have edited the scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeChangeResourceGetEditors(schemeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeChangeResourceGetEditors(schemeId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SchemeChangesApi.schemeChangeResourceGetEditors']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.SchemeChangesApiFp = SchemeChangesApiFp;
/**
 * SchemeChangesApi - factory interface
 * @export
 */
const SchemeChangesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SchemeChangesApiFp)(configuration);
    return {
        /**
         * Get scheme edits
         * @param {SchemeChangesApiGetSchemeHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemeHistory(requestParameters, options) {
            return localVarFp.getSchemeHistory(requestParameters.schemeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get scheme edits, done by other user
         * @param {SchemeChangesApiGetSchemeHistoryForUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemeHistoryForUser(requestParameters, options) {
            return localVarFp.getSchemeHistoryForUser(requestParameters.otherUser, requestParameters.schemeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get other users that have edited the scheme
         * @param {SchemeChangesApiSchemeChangeResourceApplyChangesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeChangeResourceApplyChanges(requestParameters, options) {
            return localVarFp.schemeChangeResourceApplyChanges(requestParameters.schemeId, requestParameters.changes, options).then((request) => request(axios, basePath));
        },
        /**
         * Get other users that have edited the scheme
         * @param {SchemeChangesApiSchemeChangeResourceGetEditorsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeChangeResourceGetEditors(requestParameters, options) {
            return localVarFp.schemeChangeResourceGetEditors(requestParameters.schemeId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SchemeChangesApiFactory = SchemeChangesApiFactory;
/**
 * SchemeChangesApi - object-oriented interface
 * @export
 * @class SchemeChangesApi
 * @extends {BaseAPI}
 */
class SchemeChangesApi extends base_1.BaseAPI {
    /**
     * Get scheme edits
     * @param {SchemeChangesApiGetSchemeHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeChangesApi
     */
    getSchemeHistory(requestParameters, options) {
        return (0, exports.SchemeChangesApiFp)(this.configuration).getSchemeHistory(requestParameters.schemeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get scheme edits, done by other user
     * @param {SchemeChangesApiGetSchemeHistoryForUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeChangesApi
     */
    getSchemeHistoryForUser(requestParameters, options) {
        return (0, exports.SchemeChangesApiFp)(this.configuration).getSchemeHistoryForUser(requestParameters.otherUser, requestParameters.schemeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get other users that have edited the scheme
     * @param {SchemeChangesApiSchemeChangeResourceApplyChangesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeChangesApi
     */
    schemeChangeResourceApplyChanges(requestParameters, options) {
        return (0, exports.SchemeChangesApiFp)(this.configuration).schemeChangeResourceApplyChanges(requestParameters.schemeId, requestParameters.changes, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get other users that have edited the scheme
     * @param {SchemeChangesApiSchemeChangeResourceGetEditorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeChangesApi
     */
    schemeChangeResourceGetEditors(requestParameters, options) {
        return (0, exports.SchemeChangesApiFp)(this.configuration).schemeChangeResourceGetEditors(requestParameters.schemeId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SchemeChangesApi = SchemeChangesApi;
//# sourceMappingURL=scheme-changes-api.js.map